export const isLogin = ()=> {
    if(localStorage.getItem('token'))
    {
        console.log("inside if islogin trueeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
        return true
    }
            console.log("inside if islogin Falseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")

    return false
}

export const isLogin1 = async () => {
  const token = localStorage.getItem('verifyToken');
  const email = localStorage.getItem('email');

  if (!token || !email) return false;

  try {
    const response = await fetch(`${process.env.REACT_APP_PORT}/api/auth/verifyTheVerifyTokenForMergeasyPasswordSession`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
       "x-auth-token": localStorage.getItem('token')
        
      },
      body: JSON.stringify({ email, token }),
    });

    const data = await response.json();
    console.log("data============from api==================",data)

    if(data.verifyToken)
    {
        localStorage.setItem('verifyToken',data.verifyToken)
    }
    return data.verified === true;
  } catch (err) {
    console.error('Token validation error:', err);
    return false;
  }
};
